export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('email');
    localStorage.removeItem('fromWhere');
    sessionStorage.clear();
};

export const saveToken = (token) => {
    localStorage.setItem('token', token);
};
